import { render } from "./HomeNew.vue?vue&type=template&id=3b44deec&scoped=true&ts=true"
import script from "./HomeNew.vue?vue&type=script&lang=ts"
export * from "./HomeNew.vue?vue&type=script&lang=ts"

import "./HomeNew.vue?vue&type=style&index=0&id=3b44deec&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b44deec"]])

export default __exports__